import { z } from "zod"

import { CarrierType, FreightTerms } from "@/graphql/codegen/graphql"

const carrierPreferenceFormSchema = z.object({
  carrierId: z.string(),
  accountNumber: z.string(),
  freightTerm: z.union([z.nativeEnum(FreightTerms), z.literal("")]),
  note: z.string(),
  comment: z.string(),
  customerPaysForSampleShipping: z.boolean().optional(),
})

export const carrierPreferencesSchema = z.record(z.nativeEnum(CarrierType), carrierPreferenceFormSchema)
